var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrikethroughComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5373_56554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.878906 8H12.4789",
    stroke: "#D6DCE8",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03984 6.80016H4.95984C4.87984 6.80016 4.79984 6.72016 4.71984 6.72016C4.23984 6.40016 3.83984 6.08016 3.59984 5.76016C3.27984 5.28016 3.11984 4.80016 3.11984 4.24016C3.11984 3.44016 3.51984 2.72016 4.15984 2.16016C4.79984 1.60016 5.75984 1.28016 6.63984 1.28016C7.51984 1.28016 8.79984 1.52016 9.75984 2.80016C9.83984 2.96016 9.99984 2.96016 10.1598 3.04016C10.3198 3.04016 10.4798 3.04016 10.5598 2.96016C10.7998 2.80016 10.8798 2.40016 10.6398 2.16016C9.67984 0.880156 8.23984 0.160156 6.63984 0.160156C5.43984 0.160156 4.31984 0.560156 3.35984 1.28016C2.39984 2.08016 1.83984 3.12016 1.83984 4.24016C1.83984 5.04016 2.07984 5.76016 2.55984 6.40016C2.79984 6.56016 2.87984 6.64016 3.03984 6.80016Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6388 9.19922H8.79876C8.87876 9.19922 8.87876 9.27922 8.95876 9.27922C9.43876 9.51922 9.83876 9.83922 10.0788 10.2392C10.3988 10.6392 10.5588 11.1192 10.5588 11.6792C10.5588 12.4792 10.1588 13.1992 9.51876 13.7592C8.87876 14.3192 7.91876 14.6392 6.95876 14.6392C6.07876 14.6392 4.79876 14.3992 3.83876 13.1192C3.75876 12.9592 3.51876 12.8792 3.35876 12.8792C3.27876 12.8792 3.11876 12.8792 3.03876 12.9592C2.87876 13.0392 2.87876 13.1992 2.79876 13.3592C2.71876 13.5192 2.79876 13.6792 2.87876 13.7592C3.83876 15.0392 5.27876 15.7592 6.87876 15.7592C8.07876 15.7592 9.19876 15.3592 10.1588 14.6392C11.1188 13.8392 11.6788 12.7992 11.6788 11.6792C11.6788 10.8792 11.4388 10.1592 11.0388 9.51922C10.8788 9.43922 10.7188 9.35922 10.6388 9.19922Z",
    fill: "#D6DCE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5373_56554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethroughComments);
export default __webpack_public_path__ + "static/media/strikethrough-comments.c01127f2f5c264662f950421bc6579ae.svg";
export { ForwardRef as ReactComponent };